// Default PLANNED durations (minutes) per activity type.
// TRANSITIONAL: mapping is keyed by the type's DISPLAY NAME (normalized). This is a minimal,
// intentional stop-gap. FUTURE: associate defaults to the stable-configurable activity type
// ID (not the display name) so a rename never drops the default. No extra infra in this lot.
const DEFAULT_DURATION_MIN = {
  "lavoro montato": 60,
  "longia": 30, // "Longia" = lavoro alla corda
};

export function defaultDurationMin(typeName) {
  return DEFAULT_DURATION_MIN[(typeName || "").trim().toLowerCase()] || null;
}

// Add minutes to an "HH:MM" string; returns "" for invalid input. Wraps within a single day.
export function addMinutesHM(hhmm, min) {
  if (!hhmm || !min) return "";
  const [h, m] = hhmm.split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return "";
  const v = ((h * 60 + m + min) % 1440 + 1440) % 1440;
  return `${String(Math.floor(v / 60)).padStart(2, "0")}:${String(v % 60).padStart(2, "0")}`;
}
